import {useEffect} from 'react';
import {UserProfile} from 'APIs/letrusAPI/user/types';

export interface ShowableDialog {
  showModal(): void;
  open?: boolean;
}

// Show-automatically half of the class-transfer notice (BO-2277, TRANSF-01) —
// dialog control is delegated to the parent via letrus-ui's useModals, per
// this project's modal convention (no internal ref inside the modal
// component).
export function useShowTransferNotice(
  userProfile: UserProfile | undefined,
  modal: ShowableDialog | null | undefined,
) {
  useEffect(() => {
    // userProfile comes from getUserData(), which re-parses localStorage on
    // every call — recent_transfer_notice is a fresh object reference on
    // every Dashboard render even when its content hasn't changed, so this
    // effect can legitimately re-run while the modal is still open (e.g. a
    // background SWR refetch of activities/notifications/contests). Guard
    // with modal.open so a second run doesn't call showModal() on an
    // already-open <dialog> (throws InvalidStateError).
    if (userProfile?.recent_transfer_notice && modal && !modal.open) {
      modal.showModal();
    }
  }, [userProfile?.recent_transfer_notice, modal]);
}

export default useShowTransferNotice;
